import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import CssCodeEditor from "../../../components/CssCodeEditor";
import ColorPicker from "../../../components/ColorPicker";
import JsCodeEditor from "../../../components/JsCodeEditor";

const StyleTab = ({ handleLayoutChange, selectedLayout,updateQRCodeTabData,qrCodeTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [qrCodeSize, setQRCode] = useState(qrCodeTabData.qr_code_size);
    const [titleColor, setTitleColor] = useState(qrCodeTabData.title_color);
    const [foregroundColor, setForegroundColor] = useState(qrCodeTabData.foreground_color);
    const [backgroundColor, setBackgroundColor] = useState(qrCodeTabData.background_color);
    const [frameColor, setFrameColor] = useState(qrCodeTabData.frame_color);
    const [captionColor, setCaptionColor] = useState(qrCodeTabData.caption_color);
    const [titleFontSize, setTitleFontSize] = useState(qrCodeTabData.title_font_size);
    const [titleFontSizeDropdownOpen, setTitleFontSizeDropdownOpen] = useState(false);
    const [callToActionFontSize, setCallToActionFontSize] = useState(qrCodeTabData.call_to_action_font_size);
    const [callToActionFontSizeDropdownOpen, setCallToActionFontSizeDropdownOpen] = useState(false);
    const [captionFontSize, setCaptionFontSize] = useState(qrCodeTabData.caption_font_size);
    const [captionFontSizeDropdownOpen, setCaptionFontSizeDropdownOpen] = useState(false);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(qrCodeTabData.custom_css);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(qrCodeTabData.custom_js);

    // Handlers QR Code Change
    const handleQRCodeSizeChange = (e) => {
        const rawValue = parseInt(e.target.value, 10);
        const MIN_SIZE = 180;
        const MAX_SIZE = 500;
        const clampedValue = Math.max(MIN_SIZE, Math.min(rawValue, MAX_SIZE));
        const valueWithPx = `${clampedValue}px`;
        setQRCode(valueWithPx); 
        updateQRCodeTabData("qr_code_size", valueWithPx);
    };

    // Handlers Title Color Change
    const handleTitleColorChange = (color) => {
        setTitleColor(color.hex);
        updateQRCodeTabData("title_color", color.hex);
    };

    // Handlers Foreground Color Change
    const handleForegroundColorChange = (color) => {
        setForegroundColor(color.hex);
        updateQRCodeTabData("foreground_color", color.hex);
    };

    // Handlers Background Color Change
    const handleBackgroundColorChange = (color) => {
        setBackgroundColor(color.hex);
        updateQRCodeTabData("background_color", color.hex);
    };

    // Handlers Frame Color Change
    const handleFrameColorChange = (color) => {
        setFrameColor(color.hex);
        updateQRCodeTabData("frame_color", color.hex);
    };

    // Handlers Caption Color Change
    const handleCaptionColorChange = (color) => {
        setCaptionColor(color.hex);
        updateQRCodeTabData("caption_color", color.hex);
    };

    // Handlers Title Font Size Change
    const handleTitleFontSizeChange = (font) => {
        setTitleFontSize(font);
        updateQRCodeTabData("title_font_size", font);
        setTitleFontSizeDropdownOpen(false);
    };

    // Handlers Call To Action Font Size Change
    const handleCallToActionFontSizeChange = (font) => {
        setCallToActionFontSize(font);
        updateQRCodeTabData("call_to_action_font_size", font);
        setCallToActionFontSizeDropdownOpen(false);
    };

    // Handlers Caption Font Size Change
    const handleCaptionFontSizeChange = (font) => {
        setCaptionFontSize(font);
        updateQRCodeTabData("caption_font_size", font);
        setCaptionFontSizeDropdownOpen(false);
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateQRCodeTabData("custom_css", code);
    };
    
    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);
    
    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateQRCodeTabData("custom_js", code);
    }; 

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => { 
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Style</span>
                    <div className="side-baar-box-header mb-3">
                        <div className="box-header-row">
                            <span>QR Code Size</span>
                            <em>{parseInt(qrCodeSize)}px</em>
                            <div className="slider-container">
                                <input
                                    type="range"
                                    min="180"
                                    max="500"
                                    value={parseInt(qrCodeSize)}
                                    onChange={handleQRCodeSizeChange}
                                />
                            </div>
                        </div>
                    </div>

                    <span>Colors</span>
                    <div className="side-baar-box-header mb-3">
                        <div className="box-header-row">
                            <span>Title Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={titleColor} setColor={setTitleColor} onChangeComplete={handleTitleColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Foreground Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={foregroundColor} setColor={setForegroundColor} onChangeComplete={handleForegroundColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Background Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={backgroundColor} setColor={setBackgroundColor} onChangeComplete={handleBackgroundColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Frame Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={frameColor} setColor={setFrameColor} onChangeComplete={handleFrameColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Caption Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={captionColor} setColor={setCaptionColor} onChangeComplete={handleCaptionColorChange}/>
                            </div>
                        </div>
                    </div>

                    <span>Fonts</span>
                    <div className="side-baar-box-header">
                         <div className="box-header-row">
                            <span>Title Font</span>
                            <div className="color-pikr-box" onClick={() => setTitleFontSizeDropdownOpen(!titleFontSizeDropdownOpen)}>
                                <em>{titleFontSize}</em>
                                {titleFontSizeDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["10px","11px","12x","13px","14px","15px","16px","17px","18px","19px","20px","22px","24px","26px","28px","30px","30px","34px","36px","40px","44px","48px","50px"].map((font) => (
                                            <li key={font} onClick={() => handleTitleFontSizeChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>

                        <div className="box-header-row">
                            <span>Call to Action Font</span>
                            <div className="color-pikr-box" onClick={() => setCallToActionFontSizeDropdownOpen(!callToActionFontSizeDropdownOpen)}>
                                <em>{callToActionFontSize}</em>
                                {callToActionFontSizeDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["10px","11px","12x","13px","14px","15px","16px","17px","18px","19px","20px","22px","24px","26px","28px","30px","30px","34px","36px","40px","44px","48px","50px"].map((font) => (
                                            <li key={font} onClick={() => handleCallToActionFontSizeChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>

                        <div className="box-header-row">
                            <span>Caption Font</span>
                            <div className="color-pikr-box" onClick={() => setCaptionFontSizeDropdownOpen(!captionFontSizeDropdownOpen)}>
                                <em>{captionFontSize}</em>
                                {captionFontSizeDropdownOpen && (
                                    <ul className="dropdown-list">
                                        {["10px","11px","12x","13px","14px","15px","16px","17px","18px","19px","20px","22px","24px","26px","28px","30px","30px","34px","36px","40px","44px","48px","50px"].map((font) => (
                                            <li key={font} onClick={() => handleCaptionFontSizeChange(font)}>
                                                {font}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default StyleTab;